import React, { useMemo } from 'react';

import { EstimateDetail } from '../../types/common/EstimateInquiryType';
import { YearSelect, MonthSelect } from '../../types/common/EstimationType';

import { culcTerm, getYearList, getMonthList, monthDisabledCheck } from '../../utils/dateUtil';

type EditEstimateRowEditTermProps = {
    estimatePatternRowNumber: number;
    estimate: EstimateDetail;
    setStateEstimateDetail: (changeEstimateDetailData: EstimateDetail, changeEstimatePatternRowNumber: number) => void;
    inputMode: boolean;
};

export const EditEstimateRowEditTerm: React.FC<EditEstimateRowEditTermProps> = ({
    estimatePatternRowNumber,
    estimate,
    setStateEstimateDetail,
    inputMode,
}) => {
    // select 年
    const yearSelectList = useMemo<Array<YearSelect>>(() => getYearList(), []);
    // select 月
    const monthSelectList = useMemo<Array<MonthSelect>>(() => getMonthList(), []);

    return (
        <div className='edit-fields'>
            <div className='field-period'>
                <h3>
                    期間
                    <span className='calc'>
                        選択された保守期間は【
                        {culcTerm(
                            estimate.startYear ?? '',
                            estimate.startMonth ?? '',
                            estimate.endYear ?? '',
                            estimate.endMonth ?? ''
                        )}
                        】です
                    </span>
                </h3>
                <div className='field-period-items'>
                    <div className='select'>
                        <select
                            value={estimate.startYear}
                            onChange={(e) =>
                                setStateEstimateDetail(
                                    { ...estimate, startYear: e.target.value },
                                    estimatePatternRowNumber
                                )
                            }
                            disabled={!inputMode}
                        >
                            {yearSelectList.map((year) => (
                                <option value={year.value} key={`startYear-${year.value}`}>
                                    {' '}
                                    {year.caption}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className='select'>
                        <select
                            value={estimate.startMonth}
                            onChange={(e) =>
                                setStateEstimateDetail(
                                    { ...estimate, startMonth: e.target.value },
                                    estimatePatternRowNumber
                                )
                            }
                            disabled={!inputMode}
                        >
                            {monthSelectList.map((month) => (
                                <option
                                    value={month.value}
                                    key={`startMonth-${month.value}`}
                                    disabled={monthDisabledCheck(
                                        month.thisYear.toString(),
                                        estimate.startYear ?? '',
                                        month.thisMonth,
                                        Number(month.value)
                                    )}
                                >
                                    {' '}
                                    {month.caption}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className='to'>から</div>
                    <div className='select'>
                        <select
                            value={estimate.endYear}
                            onChange={(e) =>
                                setStateEstimateDetail(
                                    { ...estimate, endYear: e.target.value },
                                    estimatePatternRowNumber
                                )
                            }
                            disabled={!inputMode}
                        >
                            {yearSelectList.map((year) => (
                                <option value={year.value} key={`endYear-${year.value}`}>
                                    {' '}
                                    {year.caption}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className='select'>
                        <select
                            value={estimate.endMonth}
                            onChange={(e) =>
                                setStateEstimateDetail(
                                    { ...estimate, endMonth: e.target.value },
                                    estimatePatternRowNumber
                                )
                            }
                            disabled={!inputMode}
                        >
                            {monthSelectList.map((month) => (
                                <option
                                    value={month.value}
                                    key={`endMonth-${month.value}`}
                                    disabled={monthDisabledCheck(
                                        month.thisYear.toString(),
                                        estimate.endYear ?? '',
                                        month.thisMonth,
                                        Number(month.value)
                                    )}
                                >
                                    {' '}
                                    {month.caption}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
        </div>
    );
};
